export const environment = {
  production: true,
  apiHost: 'https://hsbooster.eu/',
  apiUrl: 'https://api-hsb2.hsbooster.eu',
};
